import React from 'react';
import { Button } from 'react-bootstrap';

import Accordion from 'components/Accordion';
import useSelectionPeriods from 'hooks/Meteorology/Weather/SeasonalForecast/useSelectionPeriods';
import TitleSemiBold from 'components/Typography/TitleSemiBold';

export default function Period() {
  const {
    setPeriodAsMonth,
    setPeriodAsTrimester,
    isMonthly,
    isTrimesterly,
  } = useSelectionPeriods();

  return (
    <Accordion.Item eventKey="period">
      <Accordion.Header>
        <TitleSemiBold>Período de seleção</TitleSemiBold>
      </Accordion.Header>
      <Accordion.Body>
        <Button
          variant="link"
          className={`text-center 
                      btn-control-panel 
                      period-pills 
                      ${isMonthly ? 'btn-control-panel-active' : ''}
                    `}
          onClick={setPeriodAsMonth}
        >
          Mensal
        </Button>
        <Button
          variant="link"
          className={`text-center 
                      btn-control-panel 
                      period-pills 
                      ${isTrimesterly ? 'btn-control-panel-active' : ''}
                    `}
          onClick={setPeriodAsTrimester}
        >
          Trimestral
        </Button>
      </Accordion.Body>
    </Accordion.Item>
  );
}
